<app-settings-base
  title="{{'ibanXSSettings.title' | translate}}"
  description="{{'ibanXSSettings.text' | translate}}"
  details="{{'ibanXSSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/ibanxs"
  canBeTested="true">
</app-settings-base>
